const floridaTitles = [{
        cName: "TRANSFER TITLE ",
        oSubMenu: [{
                cName: "VEHICLE, Private Use, TRANSFER",
                cReturn: "VEHICLE, Private Use, TRANSFER OF FLORIDA TITLE|75.25|1"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Auto (not Pickup or Truck), TRANSFER",
                cReturn: "VEHICLE, TRANSFER OF FLORIDA TITLE,  Auto, Lease or For Hire|54.25|6"
            }, //DONE
            {
                cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc), TRANSFER",
                cReturn: "VEHICLE, TRANSFER OF FLORIDA TITLE, Lease or For Hire, Not Auto (Pickup, Truck, etc)|75.25|1"
            },
            {
                cName: "MOBILE HOME, Private or Lease, TRANSFER",
                cReturn: "MOBILE HOME, TRANSFER OF FLORIDA TITLE|75.25|4"
            },
            {
                cName: "VESSEL TRANSFER,",
                cReturn: "VESSEL, TRANSFER OF FLORIDA TITLE|5.25|5"
            },
            {
                cName: "OFF-HIGHWAY VEHICLE, TRANSFER, with title decal",
                cReturn: "OFF-HIGHWAY VEHICLE, TRANSFER FLORIDA TITLE, with title decal / WITH OR WITHOUT LIEN|42.50|7"
            }, //40.25?
            {
                cName: "TRAILER < 1999 lbs - No Title required",
                bEnabled: false,
                cReturn: "Trailer < 1999 lbs - No Title required|0.00|2"
            },
            {
                cName: "Moped - No Title required",
                bEnabled: false,
                cReturn: "Moped - No Title required|0.00|2"
            },
            {
                cName: "Motorcycle < 2 BHP and 50 CC - No Title required",
                bEnabled: false,
                cReturn: "Motorcycle < 2 BHP and 50 CC - No Title required |0.00|2"
            },
            {
                cName: "Motorized Bicycle - No Title required",
                bEnabled: false,
                cReturn: "Motorized Bicycle - No Title required |0.00|2"
            }
        ]
    },
    {
        cName: "DUPLICATE TITLE",
        oSubMenu: [{
                cName: "VEHICLE, Private Use, DUPLICATE TITLE,",
                cReturn: "VEHICLE, Private Use, DUPLICATE TITLE|75.25|1"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Autos (not Pickup or Truck), DUPLICATE TITLE",
                cReturn: "VEHICLE, Auto, Lease or For Hire, DUPLICATE TITLE|54.25|6"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc), DUPLICATE TITLE",
                cReturn: "VEHICLE, DUPLICATE TITLE, Lease or For Hire, Not Auto (Pickup, Truck, etc)|75.25|1"
            },
            {
                cName: "MOBILE HOME, Private or Lease, DUPLICATE TITLE,",
                cReturn: "MOBILE HOME, DUPLICATE TITLE|75.25|4"
            },
            {
                cName: "VESSEL, DUPLICATE TITLE,",
                cReturn: "VESSEL, DUPLICATE TITLE|6.00|5"
            },
            {
                cName: "OFF-HIGHWAY VEHICLE, DUPLICATE TITLE, with title decal",
                cReturn: "OFF-HIGHWAY VEHICLE, DUPLICATE TITLE, with title decal / WITH OR WITHOUT LIEN|28.50|7"
            },
            {
                cName: "OFF-HIGHWAY VEHICLE, MODIFY TITLE, with title decal",
                cReturn: "OFF-HIGHWAY VEHICLE, MODIFY TITLE, with title decal, issuing DUPLICATE and ADDING LIEN|28.50|7"
            }
        ]
    }, {
        cName: "DUPLICATE WITH TRANSFER",
        oSubMenu: [{
                cName: "VEHICLE, Private Use, DUPLICATE TITLE WITH TRANSFER,",
                cReturn: "VEHICLE, Private Use, DUPLICATE TITLE WITH TRANSFER|150.50|1"
            },
            {
                cName: "VEHICLE, Lease or For Hire,  Autos (not Pickup or Truck), DUPLICATE WITH TRANSFER",
                cReturn: "VEHICLE, Lease or For Hire,  Auto, DUPLICATE TITLE WITH TRANSFER|108.50|6"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc),  DUPLICATE WITH TRANSFER",
                cReturn: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc) , DUPLICATE TITLE WITH TRANSFER|150.50|1"
            },
            {
                cName: "MOBILE HOME, Private or Lease, DUPLICATE WITH TRANSFER",
                cReturn: "MOBILE HOME, DUPLICATE TITLE WITH TRANSFER|150.50|4"
            },
            {
                cName: "VESSEL, DUPLICATE TITLE WITH TRANSFER,",
                cReturn: "VESSEL, DUPLICATE TITLE WITH TRANSFER|11.25|5"
            },
            {
                cName: "OFF-HIGHWAY VEHICLE, DUPLICATE WITH TRANSFER",
                cReturn: "OFF-HIGHWAY VEHICLE, DUPLICATE TITLE WITH TRANSFER|48.75|7|7"
            }
        ] // 48.75 PLUS .50 ADD AS  3RD BRANCH FEE REQUIRED - DUP, TITLE, TITLE DECAL, ALL 3 TAKE global.BFfee
    }, // Duplicate Title Application with Transfer to Application for Salvage or Certificate of Destruction!!
    {
        cName: "DUPLICATE WITH TRANSFER to Application for Salvage or Certificate of Destruction",
        oSubMenu: [{
                cName: "VEHICLE, Private Use, DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)",
                cReturn: "VEHICLE, Private Use, DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)|82.50|1"
            },
            {
                cName: "VEHICLE, Lease or For Hire,  Autos (not Pickup or Truck), DUPLICATE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)",
                cReturn: "VEHICLE, Lease or For Hire,  Auto, DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)|61.50|6"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc),  DUPLICATE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)",
                cReturn: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc) , DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)|82.50|1"
            },
            {
                cName: "MOBILE HOME, Private or Lease, DUPLICATE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)",
                cReturn: "MOBILE HOME, DUPLICATE TITLE WITH TRANSFER |82.50|4"
            },
            {
                cName: "VESSEL, DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)",
                cReturn: "VESSEL, DUPLICATE TITLE WITH TRANSFER (to Application for Salvage or Certificate of Destruction)|13.25|5"
            }
        ]
    },
    // Lien only or lien add
    {
        cName: "RECORDING OF LIEN, CURRENT FLORIDA TITLE, No Transfer",
        oSubMenu: [{
                cName: "LIEN ONLY (Subsequent Liens using 82139 and 82140), NOT For Hire",
                cReturn: "LIEN ONLY, NOT For Hire|74.25|8|1|2"
            },
            {
                cName: "LIEN ONLY (Subsequent Liens using 82139 and 82140), FOR HIRE",
                cReturn: "LIEN ONLY, FOR HIRE|53.25|8|1|2"
            },
            {
                cName: "VESSEL, LIEN ONLY (Subsequent Liens using 82139 and 82140)",
                cReturn: "VESSEL, LIEN ONLY|6.25|8|5|2"
            },
            {
                cName: "LIEN ADD (Title and 82139), NOT For Hire",
                cReturn: "LIEN ADD, NOT For Hire|74.25|8|1"
            },
            {
                cName: "LIEN ADD (Title and 82139), FOR HIRE",
                cReturn: "LIEN ADD, FOR HIRE|53.25|8|1"
            },
            {
                cName: "OFF-HIGHWAY, LIEN ADD (Title and 82139),",
                cReturn: "OFF-HIGHWAY LIEN ADD, with title decal|39.50|7"
            },
            {
                cName: "VESSEL, LIEN ADD (Title and 82139)",
                cReturn: "VESSEL, LIEN ADD|6.25|8|5"
            }
        ]
    }, // Repossession
    {
        cName: "REPOSSESSION BY LIENHOLDER",
        oSubMenu: [{
                cName: "Repossession by Lienholder (TITLE)",
                cReturn: "Repossession by Lienholder (TITLE), FLORIDA TITLE|75.25|8"
            },
            {
                cName: "Repossession by Lienholder (CERTIFICATE OF REPOSSESSION)",
                cReturn: "Repossession by Lienholder (CERTIFICATE OF REPOSSESSION), FLORIDA TITLE|75.25|8|0|2"
            },
            {
                cName: "Repossession by Lienholder, FOR HIRE, (TITLE)",
                cReturn: "Repossession by Lienholder, FOR HIRE, (TITLE), FLORIDA TITLE|54.25|8"
            },
            {
                cName: "Repossession by Lienholder, FOR HIRE, (CERTIFICATE OF REPOSSESSION)",
                cReturn: "Repossession by Lienholder, FOR HIRE, (CERTIFICATE OF REPOSSESSION), FLORIDA TITLE|54.25|8|0|2"
            },
            {
                cName: "Vessel Repossession by Lienholder (TITLE)",
                cReturn: "Vessel Repossession by Lienholder (TITLE), FLORIDA TITLE|5.25|5"
            },
            {
                cName: "Vessel Repossession by Lienholder (CERTIFICATE OF REPOSSESSION)",
                cReturn: "Vessel Repossession by Lienholder (CERTIFICATE OF REPOSSESSION), FLORIDA TITLE|5.25|5|0|2"
            },
            {
                cName: "Off-Highway Vehicle Repossession by Lienholder (TITLE)",
                cReturn: "Off-Highway Vehicle Repossession by Lienholder (TITLE), FLORIDA TITLE|42.50|7"
            },
            {
                cName: "Off-Highway Vehicle Repossession by Lienholder (CERTIFICATE OF REPOSSESSION)",
                cReturn: "Off-Highway Vehicle by Lienholder (CERTIFICATE OF REPOSSESSION), FLORIDA TITLE|42.50|7|0|2"
            },
            {
                cName: "Duplicate Certificate of Repossession by Lienholder",
                cReturn: "Duplicate Certificate of Repossession by Lienholder, FLORIDA TITLE|75.25|8"
            },
            {
                cName: "Reassignment PLUS Repossession by Lienholder",
                cReturn: "Reassignment PLUS Repossession by Lienholder, FLORIDA TITLE|78.25|8"
            }
        ]
    }, //Salvage, Rebuilt, CD and Wrecker Liens
    {
        cName: "SALVAGE Application",
        oSubMenu: [{
                cName: "Salvage title application",
                cReturn: "Salvage title application, FLORIDA TITLE|7.25|8"
            },
            {
                cName: "Duplicate Salvage title application",
                cReturn: "Duplicate Salvage title application, FLORIDA TITLE|7.25|8"
            }
        ]
    }, {
        cName: "REBUILT Application",
        oSubMenu: [{
                cName: "REBUILT VEHICLE, Private Use",
                cReturn: "REBUILT VEHICLE, Private Use, FLORIDA TITLE (includes $40 inspection fee)|115.25|1"
            },
            {
                cName: "REBUILT VEHICLE, FOR HIRE",
                cReturn: "REBUILT VEHICLE, FOR HIRE, FLORIDA TITLE (includes $40 inspection fee)|94.25|2"
            }
        ]
    }, {
        cName: "CERTIFICATE OF DESTRUCTION",
        oSubMenu: [{
                cName: "CERTIFICATE OF DESTRUCTION",
                cReturn: "CERTIFICATE OF DESTRUCTION, FLORIDA TITLE|7.25|8|0|2"
            },
            {
                cName: "DUPLICATE CERTIFICATE OF DESTRUCTION",
                cReturn: "DUPLICATE CERTIFICATE OF DESTRUCTION|7.25|8|0|2"
            }
        ]
    }, {
        cName: "DERELICT VEHICLE CERTIFICATE",
        oSubMenu: [{
                cName: "DERELICT VEHICLE CERTIFICATE",
                cReturn: "DERELICT VEHICLE CERTIFICATE|8.00|8|0|2"
            },
            {
                cName: "DUPLICATE DERELICT VEHICLE CERTIFICATE",
                cReturn: "DUPLICATE DERELICT VEHICLE CERTIFICATE|8.00|8|0|2"
            }
        ]
    }, {
        cName: "CHILD SUPPORT LIEN",
        oSubMenu: [{
            cName: "CHILD SUPPORT LIEN FEE",
            cReturn: "CHILD SUPPORT LIEN FEE|7.00|8"
        }]
    }, {
        cName: "WRECKER OPERATOR LIENS",
        oSubMenu: [{
            cName: "WRECKER OPERATOR LIEN FEE",
            cReturn: "WRECKER OPERATOR LIEN FEE|4.50|8"
        }]
    }];

module.exports = floridaTitles;



// WEBPACK FOOTER //
// ./src/modules/data/florida-titles.js